import { mapGetters, mapMutations } from "vuex"

var mixin = {
	data () {
		return {
			qRowDefault: 25,
		}
	},
	computed: {
		...mapGetters(['getApiBackend', 'getHistoryMessage', 'getInitSystem', 'getLoginSystem', 'getClientSystem', 'getHeaders', 'getPeriod', 'getEnvironmentCurrent']),
	},
	filters: {
		formatNumber (amount) {
            let decimals = 0, signo = '.'
            amount += ''; // por si pasan un numero en vez de un string
            amount = parseFloat(amount.replace(/[^0-9\.\-]/g, '')); // elimino cualquier cosa que no sea numero o punto
    
            decimals = decimals || 0; // por si la variable no fue fue pasada
    
            // si no es un numero o es igual a cero retorno el mismo cero
            if (isNaN(amount) || amount === 0) 
                return parseFloat(0).toFixed(decimals);
    
            // si es mayor o menor que cero retorno el valor formateado como numero
            amount = '' + amount.toFixed(decimals);
    
            var amount_parts = amount.split('.'),
                regexp = /(\d+)(\d{3})/;
    
            while (regexp.test(amount_parts[0]))
                amount_parts[0] = amount_parts[0].replace(regexp, '$1' + signo + '$2');
    
            return amount_parts.join('.');
        },
	},
	methods:{
		...mapMutations(['setHeadersAuthorization', 'setHistoryMessage', 'setInitSystem', 'setLoginSystem', 'setClientSystem', 'setPeriod']),
		axiosLocal(method, url, responseFunction, data = null, headers = null) {
			this.axiosSystem(method, url, responseFunction, data, headers)
		},
		changeEnv() {
			if(process.env.NODE_ENV == 'development') {
				console.log(localStorage.getItem('environment'))
				this.$awn.confirm('¿Cambiar de ambiente?', () => {
					if(localStorage.getItem('environment') == null || localStorage.getItem('environment') == 'development') {
						localStorage.setItem('environment', 'production')
					} else {
						localStorage.removeItem('environment')
					}
				})
			}
		},
		checkDataLength(value, length, con = '<') {
			value = value.replace(' ', '');
			if(con ==  '<') {
				if(value.trim().length < length)
					return false
			} else if(con ==  '==') {
				if(value.trim().length != length)
					return false					
			}
			return true
		},
		checkDigitoRUT(stringRUT) {
			if(stringRUT === null) {
				return false
			}  
			let soloRUT = stringRUT.split('-')
			if(soloRUT.length!=2)
				return false //El Formato del rut es invalido
			let digito = this.searchDigitoRUT(soloRUT[0])
			return (String(digito).toUpperCase() == String(soloRUT[1]).toUpperCase())
		},
		currentDate(days = 0) {
			let today = new Date();

			today.setDate(today.getDate() + days);

			let dd = today.getDate();
			let mm = today.getMonth()+1; //January is 0!
			let yyyy = today.getFullYear();

		    dd = (dd<10) ? '0' + dd : dd;
		    mm = (mm<10) ? '0' + mm : mm;

			let current = yyyy + '-' + mm + '-' + dd;		
			return current;
		},
		generateString(length) {
			let characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			let result = ' ';
			let charactersLength = characters.length;
			for ( let i = 0; i < length; i++ ) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength));
			}
			return result;
		},
		goToHome() {
			this.$router.push('/')
		},
		initModule() {
			console.clear()
			console.log('Inicializando modulo ' + this.$router.history.current.name)
			this.initModuleLocal()
		},
		initModuleLocal() {
			console.log('initModuleLocal no está configurado en el modulo')
		},
		searchDigitoRUT(stringRUT) {
			if(stringRUT === null)
				return false
			let soloRUT = stringRUT.split("-");
			stringRUT = soloRUT[0];
			stringRUT = stringRUT.split('.').join('');
			stringRUT = stringRUT.split(',').join('');
			let cont = 7;
			let suma = 0;
			if (isNaN(stringRUT))
				return -1; //El Rut contiene valores alfanumericos
			for(let i=stringRUT.length-1;i>-1;i--) {
				cont = (cont==7)?2:cont+1;
				suma+= stringRUT[i]*cont;
			}
			return (11-(suma%11)==10)?'K':((11-(suma%11)==11)?'0':(11-(suma%11)));
		},
		validateEmail(mail) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
                return true
            }
            return false
        },
	},
}

export default mixin;